module.exports = __webpack_public_path__ + "img/cert1.97219ce2.jpg";